/* eslint-disable max-lines */
import {
    LoadFreeHandlingFeeResult,
    SetFreeHandlingFeeParam,
    Void,
    SetFreeHandlingFeeRuleResult,
    SetFreeHandlingFeeRuleParam,
    QueryHandlingFeeChannelParam,
    HandlingFeeChannelResult,
    LabelLibraryResult,
    ChannelLabelParam,
    UpdateChannelLabelResult
} from '@servicesTypings/drpRequestV3'
import { WsFeeConfigV2Vo } from '@servicesTypings/payRequestV3'
import {
    ListUsingGetParams,
    ActivityVo,
    LookForConfigDto,
    QueryDisplayImageVo,
    SaveDisplayImageParam,
    SaveDisplayImageVo,
    QueryChannelDisplayImageParam,
    QueryChannelDisplayImageVo,
    QuerySupplierUsingGetParams,
    PartnerSupplierVo,
    AllowSiteGoodsParam,
    UpdateAllowSiteGoodsParam,
    QueryTransparentFreightSwitchParam,
    QueryTransparentFreightSwitchVo,
    SaveTransparentFreightSwitchParam,
    SyncRegulatePriceParam,
    BatchCancelParam,
    BatchEndResult,
    DockingPeopleConfigVo,
    IsPartnerByCoIdUsingGet3Params,
    IsPartnerByCoIdUsingGet2Params,
    RelatedDiscountRateUsingGet1Params,
    RelatedDiscountRateView,
    SatisfiedApplyVo,
    CoConfig,
    UserNoticeView,
    UserNotice,
    UpdateUrgeTimeParam,
    MultiChannelsParam,
    DisPerformanceResult,
    SupplierUpdateUrgeTimeParam,
    BatchConfirmParam,
    GetSubAccountListOptionsUsingGetParams,
    CompanyUserManageVo,
    SupplierAuditConfigVo,
    MultiCoIdsParam,
    TodayPojiaGoodsNumVo,
    ConfirmLookForNoticeParam,
    LabelLibraryParam,
    QueryPartnerLogUsingGetParams,
    CommonActionLogResult,
    QueryPartnerLogUsingGet1Params,
    LiveActivityConfigResult,
    UpdatePayForChannelParam,
    SetDefaultPayForChannelParam,
    PartnerLookingForSourceResult,
    ShouldReduceApplyCountUsingGet1Params,
    ShouldReduceApplyCountUsingGetParams,
    OpDisPartnerParam,
    PartnerCooperationVo,
    SupplierApplyParam,
    SupplierApplyResp,
    ChannelApplyParam,
    SupplierConfirmParam
} from '@servicesTypings/drpRequest'
import { QueryCommonLogParam } from '@servicesTypings/towerDrpRequestV3'
import {
    ListChannelFundParam,
    ChannelFund,
    FeeTooHighLogisticsResult,
    QueryMergedLogisticsForbiddenAreaUsingGetParams,
    AreaDataVo
} from '@servicesTypings/towerDrpRequest'
import {
    IsFreshmanCompanyAndWhiteListUsingGet2Params,
    CoIdAndSpuId,
    DisPartnerVo,
    CheckShelvesParam,
    CanShelvesItemVo,
    PreShelvesGoodsInfoParam,
    NotPerfectGoodsInfo,
    ShelvesItemVo,
    BatchShelvesItemsVo,
    QueryTaskUsingGet1Params,
    GoShelvesTask,
    PreShelvesConfigParam,
    BasePublicParam,
    ShelvesGoodsInfo,
    PlatformCanUpdateBaseDataUsingGetParams,
    PlatformCanUpdateBaseData,
    PlatformUpdateBaseDataUsingGetParams,
    QueryShelveShopsByShelveProgressIdUsingGetParams,
    SimpleShopInfo,
    UpdateFreightTemplateVo,
    SupplierGoodsCheckVo,
    XiaohsQueryDeliveryRuleBySpuIdParam,
    XiaohsQueryDeliveryRuleResult,
    QueryShowDetailUsingGet1Params,
    FreshmanSpuDetailVo,
    SyncSupplierUserCateVo
} from '@servicesTypings/goodsRequest'
import { WidgetVo } from '@servicesTypings/marketRequest'

import {
    companyRequest,
    goodsRequest,
    drpRequest,
    payRequest,
    marketRequest,
    towerDrpRequest,
    goodsBasicRequest
} from '@/utils/request'
import { getCacheService } from '@/utils/requestUtils'

import checkDataIsBig from '@/utils/checkDataIsBig/index'
// 我的分销商

// 供应商是否有合作关系(渠道PC使用)
/**
 * 供应商是否有合作关系(渠道PC使用)
 */
export function checkIsPartner(params: IsPartnerByCoIdUsingGet3Params): API.Res<boolean> {
    return drpRequest.get('/myPartner/supplierIsPartner', { params })
}

// 是否有合作关系
/**
 * 是否合作关系
 */
export function checkIsPartnerByCoId(params: IsPartnerByCoIdUsingGet2Params): API.Res<boolean> {
    return drpRequest.get('/myPartner/isPartnerByCoId', { params })
}

// 批量检测是否合作关系
/**
 * 根据商品id列表查询与供应商合作关系
 */
export function checkBatchIsPartner(data: CoIdAndSpuId[]): API.Res<DisPartnerVo[]> {
    return goodsRequest.post('/buyer/shelves/listPartnerByItemSpuIds', { data })
}

// 根据商品ID列表查询是否可铺货
/**
 * 根据商品ID列表查询是否可铺货
 */
export function checkBatchCanShelves(data: CheckShelvesParam[]): API.Res<CanShelvesItemVo[]> {
    return goodsRequest.post('/buyer/shelves/canShelvesByItemSpuIds', { data })
}

// 申请合作（渠道侧专用）
function applyCooperation(data) {
    return drpRequest.post('/myPartner/channelApplyByCoId', { data })
}

// 申请合作，简化参数
export const applyCooperationProxy = ({ supplierCoId, remark, applySource, applySourceV2 }) => {
    return applyCooperation({
        supplierCoId,
        remark: remark?.trim(),
        originator: window.PROJECT_CONFIG.terminalName,
        // 合作类型,可用值:NORMAL_APPLY,FAST_COOP_APPLY,MARKET_COOP_APPLY,PURCHASE_COOP_APPLY
        cooperationType: window.TERMINANAME_IS_SQMALL ? 'MARKET_COOP_APPLY' : 'NORMAL_APPLY',
        applySource,
        applySourceV2
    })
}

// 申请合作 寻合作找分销商  需要协议
export function applyCooperationForFindChannelV3(data) {
    return drpRequest.post('/partner/supplier/apply', { data })
}

// 申请合作 寻合作找分销商  需要协议 前置校验
export function findCooperationApply(data) {
    return drpRequest.post('/partner/supplier/findCooperationApply', { data })
}

// 获取未完善的商品信息
/**
 * 获取未完善的商品信息
 */
export function queryNotPerfectGoodsInfo(data: PreShelvesGoodsInfoParam): API.Res<NotPerfectGoodsInfo[]> {
    return goodsRequest.post('/preBatchShelves/queryNotPerfectGoodsInfo', { data })
}

// 校验批量铺货商品是否可发布到该平台
/**
 * 批量铺货前置校验
 */
export function checkBatchShelvesPermissions(data: ShelvesItemVo): API.Res<BatchShelvesItemsVo> {
    return goodsRequest.post('/buyer/shelves/checkBatchShelvesPermissions', { data })
}

// 批量铺货 渠道 供应商
export function batchDistribute(data) {
    if (PROJECT_CONFIG.terminalName === 'SUPPLIER') {
        checkDataIsBig(data, '/supplier/shelves/batchShelves')
        // 供应商
        return goodsRequest.post('/supplier/shelves/batchShelves', {
            data
        })
    } else {
        checkDataIsBig(data, '/buyer/shelves/batchShelves')
        // 渠道
        return goodsRequest.post('/buyer/shelves/batchShelves', {
            data
        })
    }
}

// 查询进度
/**
 * 查询任务日志
 */
export function queryDistributeProgress(params: QueryTaskUsingGet1Params): API.Res<GoShelvesTask> {
    return goodsRequest.get('/goods/goShelvesTask/queryTaskV2', { params })
}

// 查询平台店铺
export function getStoresList(params) {
    const goodsRequestCache = getCacheService(goodsRequest)
    return goodsRequestCache.get('/shelves/mxStoresInformation/selectStoresInfo', {
        params
    })
}

// 获取拼多多批量设置
/**
 * 获取拼多多批量铺货设置
 */
export function queryPddBatchShelvesConfig(data: PreShelvesConfigParam): API.Res<BasePublicParam> {
    return goodsRequest.post('/preBatchShelves/pddBatchShelvesConfig', { data })
}

// 获取抖音批量设置
/**
 * 获取抖音批量铺货设置
 */
export function queryDyBatchShelvesConfig(data: PreShelvesConfigParam): API.Res<BasePublicParam> {
    return goodsRequest.post('/preBatchShelves/douyinBatchShelvesConfig', { data })
}

// 获取快手批量设置
/**
 * 获取快手批量铺货设置
 */
export function queryKsBatchShelvesConfig(data: PreShelvesConfigParam): API.Res<BasePublicParam> {
    return goodsRequest.post('/preBatchShelves/kuaishouBatchShelvesConfig', { data })
}

// 获取淘宝批量设置
/**
 * 获取淘宝批量铺货设置
 */
export function queryTbBatchShelvesConfig(data: PreShelvesConfigParam): API.Res<BasePublicParam> {
    return goodsRequest.post('/preBatchShelves/taobaoBatchShelvesConfig', { data })
}

// 获取淘特批量设置
/**
 * 获取淘特批量铺货设置
 */
export function queryLtBatchShelvesConfig(data: PreShelvesConfigParam): API.Res<BasePublicParam> {
    return goodsRequest.post('/preBatchShelves/liteTaoBatchShelvesConfig', { data })
}

// 获取天猫批量设置
/**
 * 获取天猫批量铺货设置
 */
export function queryTMallBatchShelvesConfig(data: PreShelvesConfigParam): API.Res<BasePublicParam> {
    return goodsRequest.post('/preBatchShelves/tMallBatchShelvesConfig', { data })
}

// 获取微信小商店批量设置
/**
 * 获取微信小商店批量铺货设置
 */
export function queryWxStoreBatchShelvesConfig(data: PreShelvesConfigParam): API.Res<BasePublicParam> {
    return goodsRequest.post('/preBatchShelves/wxStoreBatchShelvesConfig', { data })
}

// 获取视频号小店批量设置
/**
 * 获取微信视频号批量铺货设置
 */
export function queryWxChannelBatchShelvesConfig(data: PreShelvesConfigParam): API.Res<BasePublicParam> {
    return goodsRequest.post('/preBatchShelves/wxChannelBatchShelvesConfig', { data })
}

// 获取京东批量设置
/**
 * 获取京东批量铺货设置
 */
export function queryJdBatchShelvesConfig(data: PreShelvesConfigParam): API.Res<BasePublicParam> {
    return goodsRequest.post('/preBatchShelves/josBatchShelvesConfig', { data })
}

// 获取商品资料
/**
 * 获取铺货的商品信息
 */
export function queryGoodsInfo(data: PreShelvesGoodsInfoParam): API.Res<ShelvesGoodsInfo[]> {
    return goodsRequest.post('/preBatchShelves/getGoodsInfo', { data })
}

// 获取剩余可申请次数
/**
 * 获取剩余可申请次数
 */
export function fetchApplyNumApi(): API.Res<number> {
    return drpRequest.get('/myPartner/getRemainingApplyNum')
}

// 获取剩余可申请极速合作次数
export function getCooperateRemainingApplyNum() {
    return drpRequest.get('/myPartner/remainingApplyNum')
}
// 极速合作
export function fastCooperation(data) {
    return drpRequest.post('/myPartner/fastCooperation', { data })
}
/**
 * 获取分销商供销商对应的分销折扣率
 */
export function getRelatedDiscountRate(params: RelatedDiscountRateUsingGet1Params): API.Res<RelatedDiscountRateView> {
    return drpRequest.get('/myPartner/relatedDiscountRate', { params })
}

// 获取找分销商剩余可申请次数
/**
 * 获取供应商的剩余可申请次数
 */
export function fetchApplyNumApiForFindChannel(): API.Res<number> {
    return drpRequest.get('/myPartner/getSupplierRemainingApplyNum')
}

// 申请合作 需要勾选协议
export function applyCooperationLimitApiV2(data) {
    return drpRequest.post('/myPartner/channelApplyForRestrictValidateAgreement', { data })
}
// 判断是否满足寻合作找供应商申请合作的门槛
/**
 * 判断是否满足寻合作找供应商申请合作的门槛
 */
export function judgeSatisfiedApplyApi(): API.Res<SatisfiedApplyVo> {
    return drpRequest.get('/channel/judgeSatisfiedApply')
}

// 供应测商家优选申请合作 需要勾选协议
export function secondaryApplyForRestrictApiV2(data) {
    return drpRequest.post('/myPartner/secondaryApplyForRestrictValidateAgreement', { data })
}

// 查询是否显示库存同步提示
/**
 * 获取显示库存同步提示
 */
export function queryShowInventorySyncTips(): API.Res<boolean> {
    return drpRequest.get('/config/getShowInventorySyncTips')
}

// 设置是否显示库存同步提示
/**
 * 设置是否显示库存同步提示
 */
export function updateShowInventorySyncTips(data: CoConfig): API.Res<object> {
    return drpRequest.post('/config/updateShowInventorySyncTips', { data })
}

// 是否可以将平台资料同步到基础资料 (阿里系资料不能用其他平台中使用)
/**
 * 是否可以将平台资料同步到基础资料
 */
export function platformCanUpdateBaseData(
    params: PlatformCanUpdateBaseDataUsingGetParams
): API.Res<PlatformCanUpdateBaseData> {
    return goodsRequest.get('/platform/updateSpu/platformCanUpdateBaseData', { params })
}

// 平台资料同步到基础资料 (阿里系资料不能用其他平台中使用)
/**
 * 平台资料同步到基础资料
 */
export function platformUpdateBaseData(params: PlatformUpdateBaseDataUsingGetParams): API.Res<object> {
    return goodsRequest.get('/platform/updateSpu/platformUpdateBaseData', { params })
}

// 是否需要控制淘系流程 (场景:商品导入顶部阿里系商品导入提示是否出现)
/**
 * 是否需要控制淘系流程
 */
export function aliPlatformUpdateSpecialControl(): API.Res<boolean> {
    return goodsRequest.post('/switchConfig/specialControl')
}

// 查询成功店铺（拼多多模板更新使用）
/**
 * 查询当前铺货进度下有铺货成功记录的店铺列表
 */
export function queryShelveShopsByShelveProgressId(
    params: QueryShelveShopsByShelveProgressIdUsingGetParams
): API.Res<SimpleShopInfo[]> {
    return goodsRequest.get('/goods/goShelvesTask/queryShelveShopsByShelveProgressId', { params })
}

// 铺货成功立即更新拼多多运费模版
/**
 * 铺货成功立即更新拼多多运费模版
 */
export function updatePddFreightTemplateForShelvesSuccess(data: UpdateFreightTemplateVo): API.Res<string> {
    return goodsRequest.post('/goods/goShelvesTask/updatePddFreightTemplateForShelvesSuccess', { data })
}

// 日志列表更新拼多多运费模版
/**
 * 从铺货日志更新拼多多运费模版
 */
export function updatePddFreightTemplateForShelvesTask(data: UpdateFreightTemplateVo): API.Res<string> {
    return goodsRequest.post('/goods/goShelvesTask/updatePddFreightTemplateForShelvesTask', { data })
}

// 查询有效店铺：已授权，启用，非线下，非自由商城
/**
 * 查询有效店铺：已授权，启用，非线下，非自由商城
 */
export function queryEffectiveShopCount(): API.Res<number> {
    return companyRequest.get('/shop/queryEffectiveShopCount')
}

// 用户提醒详情
/**
 * 用户提醒详情
 */
export function userNoticeDetail(): API.Res<UserNoticeView> {
    return drpRequest.get('/userNotice/detail')
}

// 修改用户提醒
/**
 * 修改用户提醒
 */
export function updateUserNotice(data: UserNotice): API.Res<object> {
    return drpRequest.post('/userNotice/update', { data })
}

// 用户提醒详情
/**
 * getOpenSpuCount
 */
export function openSpuCount(): API.Res<number> {
    return goodsRequest.get('/statistics/distribution/openSpuCount')
}

// 查询类目主题活动-新
export function queryCateActivity() {
    return drpRequest.get('/mainCategory/queryCateActivity')
}

// 供应商推广商品
/**
 * 校验商品是否是供应商平台资料
 */
export function supplierGoodsCheck(data: CoIdAndSpuId[]): API.Res<SupplierGoodsCheckVo[]> {
    return goodsRequest.post('/buyer/supplier/supplierGoodsCheck', { data })
}

// 获取订单推送设置
// 分销商订单推送时判断库存，库存不足时拦截订单推送
export function getStockLimitConfig(params) {
    const drpRequestCache = getCacheService(drpRequest)
    return drpRequestCache.get('/disConfig/getOrderInterceptRules', {
        params
    })
}

// 查询代发商品导入是否上架到分销小站配置
export function queryDrpGoodsConfig(data) {
    return goodsBasicRequest.post('/disImport/config/queryConfig', {
        data
    })
}

// 编辑代发商品导入是否上架到分销小站配置
export function editDrpGoodsConfig(data) {
    return goodsBasicRequest.post('/disImport/config/editConfig', {
        data
    })
}

// 查询商家是否配置分销折扣率
/**
 * 是否配置分销折扣率
 */
export function isConfigDiscountRate(): API.Res<boolean> {
    return drpRequest.get('/disConfig/isConfigDiscountRate')
}

// 催一催 修改催促合作时间
/**
 * 修改催促合作时间
 */
export function updateUrgeTime(data: UpdateUrgeTimeParam): API.Res<object> {
    return drpRequest.post('/mySupplier/updateUrgeTime', { data })
}

// 获取自动增加的合作次数
/**
 * 获取分销商已增加申请合作次数
 */
export function getAddChannelApplyTimes(): API.Res<number> {
    return drpRequest.get('/buyer/channel/getAddChannelApplyTimes')
}

// 获取供应商自动增加的合作次数
/**
 * 获取供应商已增加申请合作次数
 */
export function getAddSupplierApplyTimes(): API.Res<number> {
    return drpRequest.get('/supplier/getAddSupplierApplyTimes')
}

// 更新自动增加合作次数
/**
 * 更新分销商剩余可申请合作次数(推单用)
 */
export function updateMaxApplyCooperationNumForAuditOrder(): API.Res<object> {
    return drpRequest.post('/buyer/channel/updateMaxApplyCooperationNumForAuditOrder')
}

// 获取小红书批量铺货设置
/**
 * 获取小红书批量铺货设置
 */
export function queryXHBookBatchShelvesConfig(data: PreShelvesConfigParam): API.Res<BasePublicParam> {
    return goodsRequest.post('/preBatchShelves/xiaohsBatchShelvesConfig', { data })
}

// 根据商品ID列表获取发货时间规则
/**
 * 根据商品ID列表获取发货时间规则
 */
export function getDeliveryRuleListBySpuId(
    data: XiaohsQueryDeliveryRuleBySpuIdParam
): API.Res<XiaohsQueryDeliveryRuleResult> {
    return goodsRequest.post('/xiaohs/shelves/getDeliveryRuleListBySpuIdV2', { data })
}

// 寻合作活动
/**
 * 查询好商活动列表
 */
export function getActivityList(params: ListUsingGetParams): API.Res<ActivityVo[]> {
    return drpRequest.get('/activity/list', { params })
}

// 寻合作活动配置
/**
 * 加载寻合作背景基础配置
 */
export function getActivityConfig(): API.Res<LookForConfigDto> {
    return drpRequest.get('/activity/getLookForConfig')
}

// 查询我的分销商资金余额置
/**
 * 查询我的分销商资金余额
 */
export function listChannelFundApi(data: ListChannelFundParam): API.Res<ChannelFund[]> {
    return drpRequest.post('/funds/listChannelFund', { data })
}

// 分销商查询自己的展示图
/**
 * 分销商查询自己的展示图
 */
export function queryDisplayImage(): API.Res<QueryDisplayImageVo> {
    return drpRequest.get('/partner/channel/queryDisplayImage')
}

// 分销商保存展示图
/**
 * 分销商保存展示图
 */
export function saveDisplayImage(data: SaveDisplayImageParam): API.Res<SaveDisplayImageVo> {
    return drpRequest.post('/partner/channel/saveDisplayImage', { data })
}

//  供应商查询分销商展示图
/**
 * 供应商查询分销商展示图
 */
export function queryChannelDisplayImage(data: QueryChannelDisplayImageParam): API.Res<QueryChannelDisplayImageVo> {
    return drpRequest.post('/partner/supplier/queryChannelDisplayImage', { data })
}

// 查询运费透传开关
/**
 * 查询运费透传开关
 */
export function queryTransparentFreightSwitch(
    data: QueryTransparentFreightSwitchParam
): API.Res<QueryTransparentFreightSwitchVo> {
    return drpRequest.post('/supplier/logistics/queryTransparentFreightSwitch', { data })
}

// 保存运费透传开关
/**
 * 保存运费透传开关
 */
export function saveTransparentFreightSwitch(data: SaveTransparentFreightSwitchParam): API.Res<boolean> {
    return drpRequest.post('/supplier/logistics/saveTransparentFreightSwitch', { data })
}

// 更新同步供应商控价
/**
 * 更新同步供应商控价
 */
export function updateSyncRegulatePrice(data: SyncRegulatePriceParam): API.Res<null> {
    return drpRequest.post('/partner/channel/updateSyncRegulatePrice', { data })
}

// 查询爆款专区商品展示明细
/**
 * 查询新人专区商品展示明细
 */
export function queryShowDetail(params: QueryShowDetailUsingGet1Params): API.Res<FreshmanSpuDetailVo> {
    return goodsRequest.get('/freshman/mall/goods/queryShowDetail', { params })
}

// 批量查询商家近30天有动销的平台店铺数
export function listCompanyPlatShopCount(data) {
    return drpRequest
        .post('/companyStatistics/listCompanyPlatShopCount', {
            data
        })
        .then(res => {
            if (Array.isArray(res.data)) {
                return {
                    ...res,
                    data: res.data.map(v => ({
                        ...v,
                        shopInfoList: Array.isArray(v.platShopCountList)
                            ? v.platShopCountList.map(v1 => ({
                                  ...v1,
                                  shopSite: v1.platName
                              }))
                            : []
                    }))
                }
            }

            return res
        })
}
// 查询我的分销商的分销业绩
/**
 * 查询我的分销商的分销业绩
 */
export function queryDisPerformance(data: MultiChannelsParam): API.Res<DisPerformanceResult[]> {
    return drpRequest.post('/partner/supplier/queryDisPerformance', { data })
}

// 同步供应商展架分类
/**
 * 同步供应商展架分类
 */
export function syncSupplierUserCategory(data: SyncSupplierUserCateVo): API.Res<object> {
    return goodsRequest.post('/goods/goUserCategory/syncSupplierUserCategory', { data })
}

// 获取合作中的供应商列表
/**
 * 获取合作中的供应商列表
 */
export function querySupplier(params: QuerySupplierUsingGetParams): API.Res<PartnerSupplierVo[]> {
    return drpRequest.get('/partner/channel/querySupplier', { params })
}

// 查询coId是否是大店商家
/**
 * 指定商家是否大店商家
 */
export function queryCoIdIsBigShop(params: IsFreshmanCompanyAndWhiteListUsingGet2Params): API.Res<boolean> {
    return goodsRequest.get('/freshman/config/isFreshmanCompany', { params })
}

/**
 * 供应商修改催促合作时间
 */
export function supplierUpdateUrgeTime(data: SupplierUpdateUrgeTimeParam): API.Res<object> {
    return drpRequest.post('/partner/supplier/supplierUpdateUrgeTime', { data })
}

/** 查询是否仅允许查看分销小站中商品  */
export const queryOnlySiteGoods = params => drpRequest.get('/partner/channel/queryAllowSiteGoods?', { params })

// 更新仅允许分销小站中商品
/**
 * 更新仅允许分销小站中商品
 */
export function updateOnlySiteGoods(data: AllowSiteGoodsParam): API.Res<null> {
    return drpRequest.post('/partner/supplier/updateAllowSiteGoods', { data })
}

// 查询仅允许分销小站中商品配置
/**
 * 查询仅允许分销小站中商品配置
 */
export function queryMyOnlySiteGoods(): API.Res<boolean> {
    return drpRequest.get('/disConfig/queryAllowSiteGoods')
}

// 更新仅允许分销小站中商品
/**
 * 更新仅允许分销小站中商品
 */
export function updateMyOnlySiteGoods(data: UpdateAllowSiteGoodsParam): API.Res<null> {
    return drpRequest.post('/disConfig/updateAllowSiteGoods', { data })
}

// 是否完善合作说明 用于大店邀请供应商的弹框里（这里是「截单时间」「售后说明」必填，才认定为【已完善】）
/**
 * 是否完善合作说明
 */
export function queryHasCompleteDisclaimer(): API.Res<boolean> {
    return drpRequest.get('/company/hasCompleteDisclaimer')
}

// 是否完善合作说明 用于我的分销小站（这里是「合作前须知」「截单时间」「售后说明」三个字段均有一个不为空就认为已完善）
/**
 * 是否完善合作说明
 */
export function queryHasCompleteDisclaimerV2(): API.Res<boolean> {
    return drpRequest.get('/company/hasCompleteDisclaimerForSite')
}

// 批量终止合作关系
// channelCoIdList
/**
 * 批量终止合作关系
 */
export function supplierBatchCancel(data: BatchCancelParam): API.Res<BatchEndResult> {
    return drpRequest.post('/partner/supplier/batchCancel', { data })
}

/**
 * 查询大店业务员对应的运营信息
 */
export function queryDockingPeople(): API.Res<DockingPeopleConfigVo> {
    return drpRequest.get('/partner/channel/queryDockingPeople')
}

// 批量同意分销商的申请时，判断是否存在合伙人邀约的分销商
/**
 * 批量同意分销商的申请时，判断是否存在合伙人邀约的分销商
 */
export function existPartnerInviteChannel(data: BatchConfirmParam): API.Res<boolean> {
    return drpRequest.post('/partner/supplier/existPartnerInviteChannel', { data })
}

/**
 * 查询业务员列表
 * @param {*} params
 * @returns
 */
/**
 * 查询业务员列表
 */
export function getSubAccountListOptions(
    params: GetSubAccountListOptionsUsingGetParams
): API.Res<CompanyUserManageVo[]> {
    return drpRequest.get('/subAccount/getSubAccountListOptions', { params })
}

/**
 * 供应商审核时查询配置
 * @param {*} params
 * @returns
 */
/**
 * 供应商审核时查询配置
 */
export function querySupplierAuditConfig(): API.Res<SupplierAuditConfigVo> {
    return drpRequest.get('/disConfig/querySupplierAuditConfig')
}

// 查询分销商今日破价商品数
/**
 * 查询分销商今日破价商品数
 */
export function queryChannelsTodayPojiaGoodsNum(data: MultiCoIdsParam): API.Res<TodayPojiaGoodsNumVo[]> {
    return drpRequest.post('/partner/supplier/queryChannelsTodayPojiaGoodsNum', { data })
}

/**
 * 查询供应商爆款专区红点信息
 * @param {*} params
 * @returns
 */
/**
 * 查询供应商爆款专区红点信息
 */
export function queryBySupplier(): API.Res<WidgetVo> {
    return marketRequest.get('/freshman/widget/queryBySupplier')
}

/**
 * 查询当前供应商是否满足入驻寻合作提醒
 * @param {*} params
 * @returns
 */
export function getLookForNotice(params) {
    const drpRequestCache = getCacheService(drpRequest)
    return drpRequestCache.get('/userNotice/getLookForNotice', { params })
}

/**
 * 提醒弹窗记录在浏览器纬度，记录点击
 * @param {*} params
 * @returns
 */
/**
 * 确认寻合作提醒
 */
export function confirmLookForNotice(data: ConfirmLookForNoticeParam): API.Res<null> {
    return drpRequest.post('/userNotice/confirmLookForNotice', { data })
}

/**
 * 查询分销商标签库
 * @returns
 */
export function listLabelLibrary() {
    return drpRequest.get('/drp/channelLabel/listLabelLibrary', {})
}
/**
 * 查询分销商查询合作次数变更日志
 * @returns
 */
export function queryChannelApplyCountLogApi(params) {
    return drpRequest.get('/partner/applyLog/queryChannelApplyCountLog', { params })
}

/**
 * 新增分销商标签
 * @param {*} data
 * @returns
 */
/**
 * 新增分销商标签
 */
export function saveLabelLibrary(data: LabelLibraryParam): API.Res<null> {
    return drpRequest.post('/drp/channelLabel/saveLabelLibrary', { data })
}

/**
 * 删除分销商标签
 * @param {*} data
 * @returns
 */
/**
 * 删除分销商标签
 */
export function deleteLabelLibrary(data: LabelLibraryParam): API.Res<null> {
    return drpRequest.post('/drp/channelLabel/deleteLabelLibrary', { data })
}

/**
 * 设置分销商标签
 * @param {*} data
 * @returns
 */
/**
 * 设置分销商标签
 */
export function modifyChannelLabel(data: ChannelLabelParam): API.Res<number> {
    return drpRequest.post('/drp/channelLabel/modifyChannelLabel', { data })
}

/**
 * 覆盖更新分销商标签
 * @param {{ channelCoId: string, labelList: string[] }} data
 * @returns {Promise}
 */
/**
 * 覆盖更新分销商标签
 */
export function coverUpdateChannelLabel(data: CoverUpdateChannelLabelParam): API.Res<null> {
    return drpRequest.post('/drp/channelLabel/coverUpdateChannelLabel', { data })
}

/**
 * 查询商家所有已启用快递中默认存在运费≥99的快递信息
 * @param {{ lcRuleEnabled: Boolean} data
 * @returns {Promise}
 */
/**
 * 查询商家所有已启用快递中默认存在运费过高的快递信息
 */
export function queryFeeTooHighLogistics(): API.Res<FeeTooHighLogisticsResult> {
    return towerDrpRequest.get('/freight/rule/queryFeeTooHighLogistics')
}

/**
 * 查询商家指定存在运费过高快递的地址与当前快递禁发地址合并后的地址信息
 * @param {lcId: string} data
 * @returns {Promise}
 */
/**
 * 查询商家指定存在运费过高快递的地址与当前快递禁发地址合并后的地址信息
 */
export function queryMergedLogisticsForbiddenArea(
    params: QueryMergedLogisticsForbiddenAreaUsingGetParams
): API.Res<AreaDataVo[]> {
    return towerDrpRequest.get('/freight/rule/queryMergedLogisticsForbiddenArea', { params })
}

/**
 * 查询商家指定存在运费过高快递的地址与当前快递禁发地址合并后的地址信息
 * @param data
 * @returns {Promise}
 */
/**
 * 获取寻合作-直播活动配置项
 */
export function queryLookForLiveActivityConfig(): API.Res<LiveActivityConfigResult> {
    return drpRequest.get('/baseConfig/queryLookForLiveActivityConfig')
}

/**
 * 修改我的分销商的代付分销服务费开关状态
 */
export function updateMyChannelPayForChannelSwitchUsingPOST(data: UpdatePayForChannelParam): API.Res<null> {
    return drpRequest.post('/myChannel/update/updateMyChannelPayForChannelSwitch', { data })
}

/**
 * queryMySupplierCountOfPayForChannel
 */
export function queryMySupplierCountOfPayForChannelUsingPOST(): API.Res<number> {
    return drpRequest.post('/mySupplier/queryMySupplierCountOfPayForChannel')
}

/**
 * 查询默认分销商代付分销服务费开关
 */
export function queryDefaultPayForChannelUsingGET(): API.Res<boolean> {
    return drpRequest.get('/disConfig/queryDefaultPayForChannel')
}

/**
 * 更新默认分销商代付分销服务费开关
 */
export function updateDefaultPayForChannelUsingPOST(data: SetDefaultPayForChannelParam): API.Res<null> {
    return drpRequest.post('/disConfig/updateDefaultPayForChannel', { data })
}

/**
 * 是否为上线时间后注册的商家
 */
export function isNewRegisteredCompanyUsingGET(): API.Res<boolean> {
    return drpRequest.get('/company/isNewRegisteredCompany')
}

/**
 * 供应商查询原因
 */
export function queryReasonsBySupplierUsingPOST(data: string[]): API.Res<PartnerLookingForSourceResult[]> {
    return drpRequest.post('/partner/lookingForSource/queryReasonsBySupplier', { data })
}

/**
 * 分销商向供应商发起申请合作，是否需要扣减次数
 */
export function shouldReduceApplyCountUsingGET1(params: ShouldReduceApplyCountUsingGet1Params): API.Res<boolean> {
    return drpRequest.get('/mySupplier/shouldReduceApplyCount', { params })
}

/**
 * 供应商向分销商发起申请合作，是否需要扣减次数
 */
export function shouldReduceApplyCountUsingGET(params: ShouldReduceApplyCountUsingGetParams): API.Res<boolean> {
    return drpRequest.get('/myChannel/shouldReduceApplyCount', { params })
}

/**
 * 申请合作（渠道商调用受限)
 */
export function channelApplyForRestrictUsingPOST1(data: OpDisPartnerParam): API.Res<PartnerCooperationVo> {
    return drpRequest.post('/myPartner/channelApplyForRestrict', { data })
}

/**
 * 供应商主动发起申请合作
 */
export function applyUsingPOST1(data: SupplierApplyParam): API.Res<SupplierApplyResp> {
    return drpRequest.post('/disPartner/coop/supplier/apply', { data })
}

/**
 * 供应商查询与分销商的关系日志
 */
export function queryPartnerLogUsingGET(params: QueryPartnerLogUsingGetParams): API.Res<CommonActionLogResult[]> {
    return drpRequest.get('/myChannel/queryPartnerLog', { params })
}
/**
 * 查询common日志
 */
export function queryCommonLog(data: QueryCommonLogParam): API.Res<CommonActionLogResult> {
    return towerDrpRequest.post('/partnerLog/queryPartnerLog', { data })
}

/**
 * 分销商查询与供应商的关系日志
 */
export function queryPartnerLogUsingGET1(params: QueryPartnerLogUsingGet1Params): API.Res<CommonActionLogResult[]> {
    return drpRequest.get('/mySupplier/queryPartnerLog', { params })
}

/**
 * 分销商主动发起申请合作
 */
export function applyUsingPOST(data: ChannelApplyParam): API.Res<null> {
    return drpRequest.post('/disPartner/coop/channel/apply', { data })
}
/**
 * 加载是否免分销商支付手续费
 */
export function loadFreeHandlingFee(): API.Res<LoadFreeHandlingFeeResult> {
    return drpRequest.get('/supplyConfig/loadFreeHandlingFee')
}

/**
 * 设置免分销商手续费
 */
export function setFreeHandlingFee(data: SetFreeHandlingFeeParam, authOptions: any): API.Res<Void> {
    return drpRequest.post('/supplyConfig/setFreeHandlingFee', { data, authOptions })
}

/**
 * 查询给分销商开通免支付手续费的供应商数量
 */
export function queryMySupplierCountOfFreeHandlingFee(): API.Res<Void> {
    return drpRequest.get('/mySupplier/queryMySupplierCountOfFreeHandlingFee')
}

/**
 * 供应商审核
 */
export function confirmUsingPOST(data: SupplierConfirmParam): API.Res<null> {
    return drpRequest.post('/disPartner/coop/supplier/confirm', { data })
}

/**
 * 查询网商手续费率、公告期配置V2
 */
export function getPayWsFeeConfigV2(): API.Res<WsFeeConfigV2Vo> {
    return payRequest.get('/order/fee/configV2')
}

/**
 * 设置免分销商手续费规则
 */
export function loadFreeHandlingFeeRule(): API.Res<SetFreeHandlingFeeRuleResult> {
    return drpRequest.get('/supplyConfig/loadFreeHandlingFeeRule')
}

/**
 * 设置免分销商手续费规则
 */
export function setFreeHandlingFeeRule(data: SetFreeHandlingFeeRuleParam, authOptions: any): API.Res<Void> {
    return drpRequest.post('/supplyConfig/setFreeHandlingFeeRule', { data, authOptions })
}

/**
 * 查询配置了支付0费用规则的分销商列表
 */
export function queryHandingFeeChannels(data: QueryHandlingFeeChannelParam): API.Res<HandlingFeeChannelResult[]> {
    return drpRequest.post('/myChannel/queryHandingFeeChannels', { data })
}

/**
 * 查询分销商标签库
 */
export function listChannelLabelLibrary(): API.Res<LabelLibraryResult[]> {
    return drpRequest.get('/drp/channelLabel/listChannelLabelLibrary')
}

/**
 * 大店分销商是否包含黑名单系统标签
 */
export function containBlackForBigShop(): API.Res<Boolean> {
    return drpRequest.get('/drp/channelLabel/containBlackForBigShop')
}

/**
 * 批量设置分销商标签
 */
export function batchUpdateChannelLabel(data: ChannelLabelParam): API.Res<UpdateChannelLabelResult> {
    return drpRequest.post('/drp/channelLabel/batchUpdateChannelLabel', { data })
}
